import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useState,
} from 'react'
import { SubtitleType } from 'service/list'
interface Props {
  subtitleTooltip: boolean
  setSubtitleTooltip: Dispatch<SetStateAction<boolean>>
  subTitleList: SubtitleType[] | undefined
}

const SubtitleToolltip = ({
  children,
  subtitleTooltip,
  setSubtitleTooltip,
  subTitleList,
}: PropsWithChildren<Props>) => {
  const subtitle = subTitleList?.filter((el) => el.cashRate === 1)[0]
  return (
    <>
      {' '}
      <img
        src="assets/img/icon_tooltip.png"
        alt="툴팁"
        className=" w-[20px] h-[20px] cursor-pointer"
        onClick={() => {
          setSubtitleTooltip(true)
        }}
      />
      {subtitleTooltip && (
        <div
          className="flex flex-col p-[16px] md:p-[32px] gap-[10px] bg-white w-[300px] md:w-[366px] h-auto absolute border-[3px] border-main  rounded-[20px]
         -bottom-20 right-14 z-50 md:left-14 md:bottom-10"
        >
          <p className="font-bold md:text-[24px] text-base flex md:items-center justify-between">
            자막은 어떻게 들어가나요?
            <button
              onClick={() => {
                setSubtitleTooltip(false)
              }}
              className="flex flex-col h-full"
            >
              <img
                src="assets/img/Icon_x.png"
                alt="icon_x"
                className="md:w-[24px] md:h-[24px] w-[25px] h-[25px]"
              />
            </button>
          </p>
          <p className=" md:leading-[19.2px] md:text-base  leading-[19.2px] text-[10px]">
            아래 숏폼 화면 예시와 같이{' '}
            <span className="text-main font-bold">
              영상에 나레이션과 동일한 내용의 자막이 들어가며,
            </span>
            {` `}자막의 위치와 사이즈는 선택에 따라 다릅니다.
          </p>

          <p className="flex flex-col">
            <div className="flex gap-2 items-center">
              <img
                src="assets/img/cash.png"
                alt="point"
                width={11}
                height={13}
              />
              <s className="text-[#5E6068]">{`${subtitle?.price}`}캐시</s>
              <span className="text-main">
                {`${subtitle?.originPrice}`}캐시
              </span>
            </div>
          </p>
          <div className="flex justify-center gap-[10px]">
            <div className="flex flex-col gap-[10px]">
              <img
                src="assets/img/subtitle_center.png"
                alt="example"
                width={100}
                height={186}
              />
              <p className="text-center font-[400] text-[14px]">화면 중앙</p>
            </div>
            <div className="flex flex-col gap-[10px]">
              <img
                src="assets/img/subtitle_top.png"
                alt="example"
                width={100}
                height={186}
              />
              <p className="text-center font-[400] text-[14px]">
                화면 상단
                <br />
                (1~2줄)
              </p>
            </div>
            <div className="flex flex-col gap-[10px]">
              <img
                src="assets/img/subtitle_bottom.png"
                alt="example"
                width={100}
                height={186}
              />
              <p className="text-center font-[400] text-[14px]">
                화면 하단
                <br />
                (1~2줄)
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default SubtitleToolltip
